import BaseInstance from "../base.instance";
import {
  MACHINE_DATA_NIP_LIST,
  MACHINE_DATA_NIP_DETAIL,
  MACHINE_DATA_NIP_SAVE,
  MACHINE_DATA_NIP_DELETE,
  MACHINE_DEVICE_LIST,
  MACHINE_DEVICE_DETAIL,
  MACHINE_DEVICE_SAVE,
  MACHINE_DEVICE_DELETE
} from "../constants";

const MachineService = {
  getListDataNIP(data) {
    return BaseInstance.post(MACHINE_DATA_NIP_LIST, data);
  },
  getDetailDataNIP(param1, param2) {
    return BaseInstance.fetch(MACHINE_DATA_NIP_DETAIL, `${param1}/${param2}`);
  },
  saveDataNIP(data) {
    return BaseInstance.post(MACHINE_DATA_NIP_SAVE, data);
  },
  deleteDataNIP(id) {
    return BaseInstance.deleteSlug(MACHINE_DATA_NIP_DELETE, id);
  },
  getListDevice(data) {
    return BaseInstance.post(MACHINE_DEVICE_LIST, data);
  },
  getDetailDevice(param1) {
    return BaseInstance.fetch(MACHINE_DEVICE_DETAIL, `${param1}`);
  },
  saveDevice(data) {
    return BaseInstance.post(MACHINE_DEVICE_SAVE, data);
  },
  deleteDevice(id) {
    return BaseInstance.deleteSlug(MACHINE_DEVICE_DELETE, id);
  }
};

export default MachineService;
